export default {
  nav: {
    title: 'Email Blaster',
    importContacts: 'Import Contacts',
  }
}
